import type { FC, ReactNode } from 'react';

import { InputTitle } from 'components/input/InputTitle';
import { FileUpload, RadiusConfig, Typography } from 'enable-ui';

import { ThumbnailCompContainer } from '../styles/thumbnail';

import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';

import { COLOR_CONFIG } from 'constants/color';

export const ThumbnailComp: FC<{
  extraClass?: string;
  title?: ReactNode;
  file: string;
  onChangeFiles: (value: File[]) => void;
  onDeleteThumbnail: () => void;
  handleGetWidthAndHeightThumbnail: (e: any) => void;
}> = ({
  file,
  onChangeFiles,
  onDeleteThumbnail,
  handleGetWidthAndHeightThumbnail,
  title,
  extraClass = '',
}) => {
  return (
    <ThumbnailCompContainer className={extraClass}>
      <InputTitle
        title={
          <Typography size={14} height={20} weight={600} color={COLOR_CONFIG['neutral-text']}>
            {title ? title : 'Class thumbnail (optional)'}
          </Typography>
        }
      />
      {file ? (
        <>
          <img
            onLoad={handleGetWidthAndHeightThumbnail}
            src={file}
            alt="thumbnail"
            style={{
              height: 178,
              borderRadius: RadiusConfig.sm,
              border: '1px solid rgba(0, 0, 0, 0.06)',
            }}
          />
          <Typography
            onClick={onDeleteThumbnail}
            style={{ padding: '12px 0 16px 21px', cursor: 'pointer', color: COLOR_CONFIG.red }}
            variant="body-3"
          >
            Remove thumbnail
          </Typography>
          {/* <ActionBtnDelete onClick={onDeleteThumbnail}>
            <DeleteIcon />
          </ActionBtnDelete> */}
        </>
      ) : (
        <FileUpload
          id={'thumbnail'}
          icon={<UploadIcon color="" />}
          title=" Click or drag and drop to upload"
          onChangeFiles={onChangeFiles}
          accept=".png,.jpeg,.svg,.webp"
          style={{ height: 200, background: '#fff' }}
        />
      )}
    </ThumbnailCompContainer>
  );
};
